import styled from '@emotion/styled';
import Color from 'color';
import { withTheme } from '@emotion/react';

export const Device = withTheme(styled.div`
    background: url('${require('./assets/iphone-frame.png')}');
    background-size: cover;
    flex-shrink: 0;
    height: ${({ theme }) => theme.height}px;
    width: ${({ theme }) => theme.width}px;
`);

export const Screen = withTheme(styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    height: ${({ theme }) => theme.height}px;
    padding: ${({ theme }) => theme.paddingVertical}px ${({ theme }) => theme.paddingHorizontal}px;
`);

export const Header = withTheme(styled.div`
    align-items: center;
    background-color: ${({ theme }) => theme.background};
    display: flex;
    height: 36px;
    justify-content: center;
`);

export const Footer = withTheme(styled.div`
    align-items: center;
    background-color: ${({ theme }) => theme.background};
    display: flex;
    flex-direction: row;
    height: 50px;
    justify-content: center;
    padding: 6px 0;
    text-align: center;
`);

export const Avatar = styled.div`
    background-color: #ededed;
    border-radius: 50%;
    height: 24px;
    margin: 4px;
    width: 24px;
`;

export const Driver = withTheme(styled.span`
    color: ${({ theme }) => (Color(theme.background).isLight() ? 'black' : 'white')};
    font-size: 10px;
`);

export const ActionButtons = withTheme(styled.div`
    color: ${({ theme }) => (Color(theme.accent).isLight() ? 'black' : 'white')};
    display: flex;
    flex-direction: row;
`);

export const ActionButton = withTheme(styled.div`
    background-color: ${({ theme }) => theme.accent};
    border-radius: 1000px;
    font-size: 10px;
    margin-left: 2px;
    margin-right: 2px;
    padding: 2px 8px;
`);

export const Mappy = styled.div<{ width: number; height: number }>`
    background: url('${require('./assets/map.png')}');
    background-position: center;
    height: ${(props) => props.height}px;
    width: ${(props) => props.width}px;
`;

export const Map = styled.div`
    background-size: cover;
    background: #d9d9d9;
    flex: 1;
    position: relative;
`;

export const MarkerWrapper = styled.div`
    left: 135px;
    position: absolute;
    top: 195px;
`;

export const ImageWrapper = styled.div`
    left: 130px;
    position: absolute;
    top: 95px;
`;
